import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import User from "../pages/User";
import SocialMediaPost from "../pages/SocialMediaPost";
import Report from "../pages/Report";
import Setting from "../pages/Setting";
import SignUp from "../pages/SignUp";
import Login from "../pages/Login";
import ProtectedRoute from "./ProtectedRoute";
import Castes from "../pages/MasterData/Castes";
import FieldsOfStudy from "../pages/MasterData/FieldsOfStudy";
import HobbiesAndInterets from "../pages/MasterData/HobbiesAndInterets";
import Languages from "../pages/MasterData/Languages";
import Qualifications from "../pages/MasterData/Qualifications";
import Religion from "../pages/MasterData/Religion";
import AbuseWord from "../pages/MasterData/AbuseWord";
import MaritalStatus from "../pages/MasterData/MaritalStatus";
import UserProfile from "../pages/UserProfile";
import UnauthorizedPage from "./UnauthorizedPage";
import ForgotPasswordEmailId from "../pages/ForgotPasswordEmailId";
import { ChangePassword } from "../pages/ChangePassword";
import ForgortPasswordMobile from "../pages/ForgortPasswordMobile";

const Routing = () => {
    const loginStatus = window.localStorage.getItem('isLoggedIn');
    const isLoggedIn = JSON.parse(loginStatus);
    const userType = window.localStorage.getItem("userType");

    return (
        <Router>
            <Routes>
                {!isLoggedIn ? (
                    <>
                        <Route path='/login' element={<Login />} />
                        <Route path='/signup' element={<SignUp />} />
                        <Route path='/' element={<Login />} />
                        <Route path='/ForgotPasswordEmailId' element={<ForgotPasswordEmailId />} />
                        <Route path='/forgetPasswordMobile' element={<ForgortPasswordMobile />} />
                        {/* <Route path='**' element={<UnauthorizedPage />} /> */}
                    </>
                ) : (
                    <Route element={<ProtectedRoute />}>
                        <Route path='/login' element={<Navigate to="/" />} />
                        <Route path='/signup' element={<Navigate to="/" />} />
                        <Route path='/ForgotPasswordEmailId' element={<Navigate to="/" />} />
                        <Route path='/forgetPasswordMobile' element={<Navigate to="/" />} />
                        {userType === "superAdmin" ? (
                            <>
                                <Route path='/' element={<Navigate to="/dashboard" />} />
                                <Route path='/dashboard' element={<Dashboard />} />
                                <Route path='/user' element={<User />} />
                                <Route path='/mediaPost' element={<SocialMediaPost />} />
                                <Route path='/maritalStatus' element={<MaritalStatus />} />
                                <Route path='/castes' element={<Castes />} />
                                <Route path='/fieldsOfStudy' element={<FieldsOfStudy />} />
                                <Route path='/hobbiesAndInterets' element={<HobbiesAndInterets />} />
                                <Route path='/languages' element={<Languages />} />
                                <Route path='/qualifications' element={<Qualifications />} />
                                <Route path='/religion' element={<Religion />} />
                                <Route path='/abuseWord' element={<AbuseWord />} />
                                <Route path='/report' element={<Report />} />
                                <Route path='/userProfile' element={<UserProfile />} />
                                <Route path='/changePassword' element={<ChangePassword />} />
                                <Route path='/setting' element={<Setting />} />
                            </>
                        ) : (
                            <>
                                <Route path='*' element={<Navigate to="/unauthorizedPage" />} />
                            </>
                        )}
                    </Route>
                )}
                <Route path='/unauthorizedPage' element={<UnauthorizedPage />} />
            </Routes>
        </Router>
    );
};

export default Routing;
